import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { motion, AnimatePresence } from 'framer-motion';

export default function Layout({ children }) {
    return (
        <div className="app-layout">
            <Header />
            <main className="main-content">
                {/* AnimatePresence currently requires keying on location in App or here if we pass location.
            For now, simpler standard layout. Page animations will be handle inside pages. */}
                {children || <Outlet />}
            </main>
            <Footer />
        </div>
    );
}
